import { atom, RecoilState } from 'recoil'
import { CurrentUser } from '../../types'

export interface CurrentUserAtom {
  firebaseInitialized: boolean
  firebaseToken: string | null
  user: CurrentUser | null
}

const currentUserAtom: RecoilState<CurrentUserAtom> = atom({
  key: 'currentUserState',
  default: {
    firebaseInitialized: false,
    firebaseToken: null,
    user: null
  } as CurrentUserAtom
})

export default currentUserAtom
